module.exports = __webpack_public_path__ + "edfdf302c93cd4a48a10ebdc1a23d927.svg";